import { Col, Progress, Row, Tag } from 'antd-v4';
import FullWidthCard from '../../../layout/components/fullwidth-card';
import { formatNumber } from '@leedpulse-monorepo/utils';

interface ProspectsInterestProgressBarProps {
  stats: {
    data: {
      interestedCount: number;
      consideringCount: number;
      notInterestedCount: number;
      notResponsiveCount: number;
      notAvailableCount: number;
    };
  };
}

const ProspectsInterestProgressBar = ({ stats }: ProspectsInterestProgressBarProps) => {
  const { interestedCount, consideringCount, notInterestedCount, notResponsiveCount, notAvailableCount } = stats.data;
  const totalCount = interestedCount + consideringCount + notInterestedCount + notResponsiveCount + notAvailableCount;
  const colors = ["#02f7bf", "#6737ff", '#b7b7b7', "#f0e289", "#FFA500"];
  const values = [interestedCount, consideringCount, notAvailableCount, notResponsiveCount, notInterestedCount];
  let cumulative = 0;

  return (
    <Col span={24}>
      <FullWidthCard
        title="Intérêt des prospects"
        subtitle={
          "Données de " + formatNumber(Math.round(totalCount)) + " contact(s)"
        }
        chart={
          <>
            <div style={{ position: "relative", height: 12, width: "100%", marginTop: '0.5rem' }}>
              {values.map((value, i) => {
                const percent = (value / totalCount) * 100;
                const left = cumulative;
                cumulative += percent;

                return (
                  <div
                    key={i}
                    style={{
                      position: "absolute",
                      left: `${left}%`,
                      width: `${percent}%`,
                      height: "100%"
                    }}
                  >
                    <Progress
                      percent={100}
                      showInfo={false}
                      strokeColor={colors[i]}
                      strokeWidth={8}
                      trailColor="transparent"
                    />
                  </div>
                );
              })}
            </div>
            <Row justify="space-between" style={{ marginTop: '1.5rem' }}>
              <Tag color='green' className='hp-d-flex-full-center'>
                <span style={{ fontSize: "44px" }} className="remix-icon hp-text-color-success-1">
                  &#8226;
                </span>{" "}
                Intéressés -{" "}
                {Math.round((interestedCount / totalCount) * 100) || 0}%
              </Tag>
              <Tag color='purple' className='hp-d-flex-full-center'>
                <span style={{ fontSize: "44px" }} className="remix-icon hp-text-color-primary-1">
                  &#8226;
                </span>{" "}
                En réflexion -{" "}
                {Math.round((consideringCount / totalCount) * 100) || 0}%
              </Tag>
              <Tag color='#b7b7b79a' className='hp-d-flex-full-center'>
                <span style={{ fontSize: "44px" }} className="remix-icon hp-text-color-alert-1">
                  &#8226;
                </span>{" "}
                À venir -{" "}
                {Math.round((notAvailableCount / totalCount) * 100) || 0}%
              </Tag>
              <Tag color='yellow' className='hp-d-flex-full-center'>
                <span style={{ fontSize: "44px" }} className="remix-icon hp-text-color-warning-1">
                  &#8226;
                </span>{" "}
                Sans réponse -{" "}
                {Math.round((notResponsiveCount / totalCount) * 100) || 0}%
              </Tag>
              <Tag color='orange' className='hp-d-flex-full-center'>
                <span style={{ fontSize: "44px" }} className="remix-icon hp-text-color-danger-1">
                  &#8226;
                </span>{" "}
                Inactifs -{" "}
                {Math.round((notInterestedCount / totalCount) * 100) || 0}%
              </Tag>
            </Row>
          </>
        }
      />
    </Col>
  );
};

export default ProspectsInterestProgressBar;
